import { sparkApi } from '@api/spark-client';
import { queryOptions } from '@tanstack/react-query';

export const serverStatusQueryOptions = queryOptions({
  queryKey: ['core', 'status'],
  queryFn: async ({ signal }) => {
    const response = await sparkApi.get<{ version: string; status: string }>('/api/status', {
      signal,
    });
    return response.data;
  },
  staleTime: 1_000,
});

export type FeatureFlagItem = {
  flag: string;
  enabled: boolean;
  // Variant information from Unleash. Variants are the mechanism Unleash uses for multivariate
  // flags / gradual rollouts (e.g., "control" vs "treatment"). For simple boolean flags the SDK
  // returns the default variant with enabled=false and no payload. When a variant is selected,
  // payload carries the typed configuration value defined in Unleash (string/json/number).
  variant: { name?: string | null; enabled: boolean; payload?: unknown };
};

export type FeatureFlagsListResponse = {
  flags: FeatureFlagItem[];
};

export const featureFlagsListQueryOptions = (userId?: string | null) =>
  queryOptions({
    queryKey: ['core', 'feature-flags', 'list', userId],
    queryFn: async ({ signal }) => {
      const response = await sparkApi.get<FeatureFlagsListResponse>('/api/feature-flags/list', {
        signal,
      });
      return response.data;
    },
    staleTime: 5_000,
  });
